import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Generateur de nombres aleatoires";
const DESCRIPTION =
  "Generateur de nombres aleatoires. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "random number generator, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/random-number-generator";
function RandomNumberGenerator() {
  const [min, setMin] = useState("0");
  const [max, setMax] = useState("100");
  const [count, setCount] = useState("1");
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null);
  const handleMinChange = (event) => {
    setMin(event.target.value);
  };
  const handleMaxChange = (event) => {
    setMax(event.target.value);
  };
  const handleCountChange = (event) => {
    setCount(event.target.value);
  };
  const generateRandomNumbers = () => {
    const minNum = parseInt(min);
    const maxNum = parseInt(max);
    const countNum = parseInt(count);
    if (
      isNaN(minNum) ||
      isNaN(maxNum) ||
      isNaN(countNum) ||
      minNum >= maxNum ||
      countNum <= 0
    ) {
      setError("Veuillez saisir des valeurs correctes.");
      setResults([]);
      return;
    }
    const randomNumbers = Array.from(
      { length: countNum },
      () => Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum
    );
    setResults(randomNumbers);
    setError(null);
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Le générateur de nombres aléatoires est un outil qui vous aide à sélectionner un nombre aléatoire ou à générer des nombres aléatoires dans une plage spécifique. Il vous permet de définir la limite inférieure et supérieure de la plage, ainsi que le nombre de nombres aléatoires que vous souhaitez générer, comme générer un nombre aléatoire de 1 à 100 ou un nombre aléatoire de 1 à 10. Cet outil est généralement utilisé dans divers domaines tels que les statistiques, le chiffrement et la simulation. Le générateur de nombres aléatoires est essentiel pour assurer l'équité dans les jeux de hasard, créer des clés de chiffrement sécurisées, mener des recherches scientifiques et tester des applications logicielles. En utilisant le générateur de nombres aléatoires, vous pouvez éliminer les biais et les prédictions, garantissant que chaque nombre généré est vraiment aléatoire et indépendant des nombres précédents.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Sélectionner un nombre aléatoire - Générateur de nombres aléatoires
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="min" className="form-label ms-2">
                      Minimum
                    </label>
                  </b>
                  <input
                    type="number"
                    id="min"
                    value={min}
                    onChange={handleMinChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="0"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="max" className="form-label ms-2">
                      Maximum
                    </label>
                  </b>
                  <input
                    type="number"
                    id="max"
                    value={max}
                    onChange={handleMaxChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="100"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="count" className="form-label ms-2">
                      Nombre de nombres
                    </label>
                  </b>
                  <input
                    type="number"
                    id="count"
                    value={count}
                    onChange={handleCountChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="1"
                  />
                </div>
                <br />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={generateRandomNumbers}
                >
                  Générer
                </button>
              </div>
              <div className="col-12 col-md-7">
                {error && <p className="alert alert-warning">{error}</p>}
                {results.length > 0 && (
                  <div className="p-3">
                    <h4>Nombres aléatoires générés :</h4>
                    <div className="alert alert-success">
                      {results.join(", ")}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <RelatedLinks />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment utiliser ce generateur</h3></div>
              <div className="info-section-body">
                <p>Definissez la valeur minimale, la valeur maximale et le nombre de tirages souhaites. En un clic, vous obtenez une serie de nombres aleatoires dans la plage choisie.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Usages frequents</h3></div>
              <div className="info-section-body">
                <p>Ce type d'outil est utile pour les tirages au sort, la generation de cas de test, les exercices de probabilite, la selection equitables de participants ou les simulations rapides.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Bonnes pratiques</h3></div>
              <div className="info-section-body">
                <p>Vérifiez que le minimum est strictement inferieur au maximum et adaptez le nombre de tirages a votre besoin. Pour des usages sensibles, notez la plage et les conditions du tirage pour plus de transparence.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default RandomNumberGenerator;
